var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.isRightVisible,
            size: "250px",
            modal: true,
            "show-close": "",
            "with-header": true,
            direction: _vm.direction,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isRightVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticStyle: { padding: "10px" } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-divider", [_vm._v("导航模式")]),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.defaultLayout,
                        callback: function ($$v) {
                          _vm.defaultLayout = $$v
                        },
                        expression: "defaultLayout",
                      },
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "横向菜单",
                            placement: "top-start",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "top" } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/top_layout.svg"),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "左侧菜单",
                            placement: "top-start",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "left" } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/left_layout.svg"),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-divider", [_vm._v("主题风格")]),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.navbarLayoutType,
                        callback: function ($$v) {
                          _vm.navbarLayoutType = $$v
                        },
                        expression: "navbarLayoutType",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "1" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/1.svg") },
                          }),
                        ]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "3" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/3.svg") },
                          }),
                        ]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "7" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/7.svg") },
                          }),
                        ]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "4" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/4.svg") },
                          }),
                        ]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "2" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/2.svg") },
                          }),
                        ]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "8" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/8.svg") },
                          }),
                        ]
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "item m-b-20", attrs: { label: "5" } },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/img/5.svg") },
                          }),
                        ]
                      ),
                      _c("el-radio", { attrs: { label: "9" } }, [
                        _c("img", {
                          attrs: { src: require("@/assets/img/9.svg") },
                        }),
                      ]),
                      _c("el-radio", { attrs: { label: "6" } }, [
                        _c("img", {
                          attrs: { src: require("@/assets/img/6.svg") },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-divider", [_vm._v("主题色")]),
                  _c(
                    "div",
                    { staticClass: "tag-group" },
                    _vm._l(_vm.colorList, function (item, index) {
                      return _c(
                        "el-tooltip",
                        {
                          key: index,
                          attrs: {
                            effect: "dark",
                            content: item.key,
                            placement: "top-start",
                          },
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              staticClass: "themeColorTag",
                              attrs: { color: item.color },
                              on: {
                                click: function ($event) {
                                  _vm.defaultTheme = item.color
                                },
                              },
                            },
                            [
                              item.color === _vm.defaultTheme
                                ? _c("i", {
                                    staticClass: "el-icon-check themeColorFont",
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", [_vm._v("其它设置")]),
              _c(
                "el-form-item",
                {
                  staticClass: "title-setting",
                  attrs: { label: "多页签模式" },
                },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.isTab,
                      callback: function ($$v) {
                        _vm.isTab = $$v
                      },
                      expression: "isTab",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }